import { getJWT } from '../Utils/Profile'
import { BASEAPI } from './constants'

const getProfileTransaction = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    return await fetch(`${BASEAPI}commerce/establishments/transfer-info`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}
const getStoreProfileData = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    return await fetch(`${BASEAPI}commerce/establishments`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

const getUnbilledSales = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    return await fetch(`${BASEAPI}commerce/establishments/unbilled-info`, {
        method: 'GET',
        headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
            Authorization: getJWT(),
        },
    })
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

const getSalesGraphic = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    return await fetch(
        `${BASEAPI}commerce/establishments/grouped-transactions?groupedBy=months&atLeastLast=5`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

const getSalesDetails = async () => {
    const currentUser = localStorage.getItem('currentUser')
    const user = currentUser && JSON.parse(currentUser)

    return await fetch(
        `${BASEAPI}commerce/establishments/unbilled-transactions?limit=20&page=1`,
        {
            method: 'GET',
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
                Authorization: getJWT(),
            },
        }
    )
        .then((response) => {
            return response.json()
        })
        .catch((error) => {
            console.error(error)
            return null
        })
}

export {
    getProfileTransaction,
    getStoreProfileData,
    getUnbilledSales,
    getSalesGraphic,
    getSalesDetails,
}
